import * as actionType from '../actionTypes';

const initialState = {
    proposalData: {},
    previewList: []
}
const proposalReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.PROPOSAL_DATA : 
        return {
            ...state,
            proposalData: {...action.payload}
        }
        case actionType.PROPOSAL_DATA_CLEAR : 
        return {
           ...initialState
        }
        case actionType.IMG_DOWNLOAD:
        const exisitingImgIndex = state.previewList.findIndex(
            (item) => item.name === action.payload.name
        );
        if (exisitingImgIndex !== -1) {
            state.previewList[exisitingImgIndex] = action.payload;
            return {
            ...state,
            previewList: [...state.previewList],
            };
        } else {
            return {
            ...state,
            previewList:
                action.payload === "clear"
                ? []
                : [...state.previewList, action.payload],
            };
        }
        default: return state
    }
}
export default proposalReducer;
